/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_5_TitleInputs */

const es_home_usecases_item_5_title = /** @type {(inputs: Home_Usecases_Item_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance y Auditoría`)
};

const en_home_usecases_item_5_title = /** @type {(inputs: Home_Usecases_Item_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance & Audit`)
};

/**
* | output |
* | --- |
* | "Compliance & Audit" |
*
* @param {Home_Usecases_Item_5_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_5_title = /** @type {((inputs?: Home_Usecases_Item_5_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_5_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_5_title(inputs)
	return en_home_usecases_item_5_title(inputs)
});
export { home_usecases_item_5_title as "home.usecases.item_5_title" }